// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__25t51","content":"Consent_content__ukk_V","footer":"Consent_footer__pRs_b"};